import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'have_any_cases_of_violence_or_threats_of_violence_to_intimidate'

export const dataPointDefinition = {
  retracedId: 'have_any_cases_of_violence_or_threats_of_violence_to_intimidate',
  name: 'Have any cases of violence or threats of violence to intimidate workers and force them to work occurred at the workplace?',
  description:
    'This includes for example, reported incidences of violence (i.e. physical aggression, hitting, punching, sexual violence) or threats (verbal statement of an intention to inflict pain, injury, damage, or other hostile action) that lead to forced labor. \r\r\n\r\r\nNote that these cases of violence or threats of violence differ from abuse or harassment, in that the employer uses violence or threats in order to coerce workers to work. One individual may be used as an example to intimidate the whole workforce.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hb-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9940,
  sectionId: '2.2.7',
  impactArea: 'Forced Labour',
  impactAreaId: 'FORCED_LABOUR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
